export const SecurityContext = {
	Host: "web_Host",
	Menu: "portal_Menu"
} as const;
